import { Accordion, ActionIcon, Badge, Box, Button, Checkbox, Grid, Loader, Paper, Text, Title, Tooltip } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { Buffer } from 'buffer';
import React, { useEffect } from 'react';
import { FaArrowLeft, FaMap, FaPencilAlt, FaSearchLocation, FaTrash } from 'react-icons/fa';
import Table from '../table';
import { formatAddress, formatDuration, getExtenseDatetime, groupBy } from '../../utility/util';
import { GET_ALL_VEHICLES, GET_VEHICLE_DETAILS } from '../../services/vehicles';
import InputField, { InputFieldTypes } from '../input_field';
import moment from 'moment';
import TrajectView from '../traject_view';

export default function Trajects({ onGenerate }){
    const [loadingVehicles, setLoadingVehicles] = React.useState<boolean>(false);
    const [loadingVehicleDetails, setLoadingVehicleDetails] = React.useState<boolean>(false);
    const [selectedVehicle, setSelectedVehicle] = React.useState<any>(null);
    const [vehicleDetails, setVehicleDetails] = React.useState<any>(null);
    const [selectedDate, setSelectedDate] = React.useState<Date>(moment().toDate());
    const [vehicles, setVehicles] = React.useState<any[]>([]);
    const [expandLocation, setExpandLocation] = React.useState<any>(null);
    
    const loadVehicles = () => {
        setLoadingVehicles(true)
        GET_ALL_VEHICLES({ children: true })
        .then((res: any[]) => {
            setVehicles(groupBy(res, item => item.company, "_id"));
            setLoadingVehicles(false);
        })
        .catch(err => {
            setLoadingVehicles(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const loadVehicleDetails = () => {
        if(selectedVehicle){
            setLoadingVehicleDetails(true)
            GET_VEHICLE_DETAILS(selectedVehicle, moment(selectedDate).format())
            .then((res) => {
                setVehicleDetails(res);
                setLoadingVehicleDetails(false);
            })
            .catch(err => {
                setLoadingVehicleDetails(false)
                showNotification({title: "Ops", message: err.message, color: 'red'})
            })
        }
    }

    useEffect(loadVehicleDetails, [selectedVehicle, selectedDate]);
    useEffect(loadVehicles, []);

    return <div>
        <Grid>
            <Grid.Col md={6}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    options={vehicles.reduce((pv,g) => {
                        return pv.concat(g[1].map(v => ({ value: v._id, group: g[0].name, label: [
                            v.license_plate,
                            v.brand,
                            v.model,
                            v.color,
                        ].filter(nn => nn).join(" / ") })))
                    }, [])}
                    value={selectedVehicle}
                    name="v"
                    onChange={({ v }) => setSelectedVehicle(v)}
                />
            </Grid.Col>
            <Grid.Col md={3}>
                <InputField
                    fieldType={InputFieldTypes.DATE}
                    value={selectedDate}
                    name="d"
                    clearable={false}
                    onChange={({ d }) => setSelectedDate(d)}
                />
            </Grid.Col>
        </Grid>

        {(loadingVehicleDetails || loadingVehicles) ? <Loader size="sm" /> : vehicles.length === 0 && <Title order={3} mt="md">Nenhum veículo cadastrado</Title>}
        {selectedVehicle && <>
            <Paper p="md" shadow='xs' mt="md">
                <Table
                    data={vehicleDetails?.totals?.trajects ?? []}
                    columns={[
                        // {
                        //     title: "A",
                        //     key: "a1",
                        //     render: (traject) => <Text ta="left" size="sm">{traject.histories[traject.histories.length - 1].data.message}</Text>
                        // },
                        {
                            title: "A",
                            key: "a1",
                            render: (traject) => <Text ta="left" size="sm">{moment(traject.histories[0].datetime).format("HH:mm")}</Text>
                        },
                        {
                            title: "Endereço",
                            key: "a2",
                            render: (traject) => <Text style={{flex: 1}} size="xs">{formatAddress({address: traject.histories[0].props?.address, location: traject.histories[0]?.props?.location})}</Text>
                        },
                        {
                            title: "Hodômetro",
                            key: "a3",
                            render: (traject) => <Text ta="left" size="sm">{(traject.histories[0]?.props?.traveled_distance / 1000).toFixed(2)} km</Text>
                        },
                        {
                            title: "B",
                            key: "b1",
                            render: (traject) => <Text ta="left" size="sm">{moment(traject.histories[traject.histories.length - 1].datetime).format("HH:mm")}</Text>
                        },
                        {
                            title: "Endereço",
                            key: "b2",
                            render: (traject) => <Text style={{flex: 1}} size="xs">{formatAddress({address: traject.histories[traject.histories.length - 1].props?.address, location: traject.histories[traject.histories.length - 1]?.props?.location})}</Text>
                        },
                        {
                            title: "Hodômetro",
                            key: "b3",
                            render: (traject) => <Text ta="left" size="sm">{(traject.histories[traject.histories.length - 1]?.props?.traveled_distance / 1000).toFixed(2)} km</Text>
                        },
                        {
                            title: "Distância",
                            key: "distance",
                            render: (traject) => <Text style={{flex: 1}} size="sm">
                                {
                                    ((
                                        traject.histories[traject.histories.length - 1]?.props?.traveled_distance -
                                        traject.histories[0]?.props?.traveled_distance
                                    ) / 1000).toFixed(2)
                                } km
                            </Text>,
                        },
                        {
                            title: "Tempo",
                            key: "period",
                            render: (traject) => <Text style={{flex: 1}} size="sm">
                                {
                                    formatDuration(
                                        moment(traject.histories[traject.histories.length - 1]?.datetime).diff(
                                            moment(traject.histories[0]?.datetime),
                                            "seconds"
                                        )
                                    )
                                }
                            </Text>,
                        },
                        {title: "", key: 'actions', render: (traject) => (
                            <Tooltip label="Ver no mapa">
                                <ActionIcon size="xs" onClick={() => {
                                    setExpandLocation({
                                        start: moment(
                                            `${moment(selectedDate).format("YYYY-MM-DD")} ${moment(traject.histories[0].datetime).format("HH:mm:ss")}`,
                                            "YYYY-MM-DD HH:mm:ss"
                                        ).format(),
                                        finish: moment(
                                            `${moment(selectedDate).format("YYYY-MM-DD")} ${moment(traject.histories[traject.histories.length - 1].datetime).format("HH:mm:ss")}`,
                                            "YYYY-MM-DD HH:mm:ss"
                                        ).format(),
                                        vehicle: { _id: selectedVehicle },
                                    })
                                }}><FaSearchLocation /></ActionIcon>
                            </Tooltip>
                        )}
                    ]}
                />
            </Paper>
            <Paper p="md" shadow='xs' mt="md">
                <Text><b>Distância Total: </b>{(vehicleDetails?.totals?.trajects ?? []).reduce((pv, t) => {
                    const vl = ((
                        t.histories[t.histories.length - 1]?.props?.traveled_distance -
                        t.histories[0]?.props?.traveled_distance
                    ) / 1000)
                    return pv + vl;
                },0).toFixed(2)} km</Text>
                <Text><b>Tempo em Movimento: </b>{formatDuration((vehicleDetails?.totals?.trajects ?? []).reduce((pv, t) => {
                    const vl = moment(t.histories[t.histories.length - 1]?.datetime).diff(
                        moment(t.histories[0]?.datetime),
                        "seconds"
                    )
                    return pv + vl;
                },0))}</Text>
            </Paper>
        </>}

        <TrajectView
            isVisible={!!expandLocation}
            data={expandLocation}
            vehicle={expandLocation?.vehicle}
            onClose={() => setExpandLocation(null)}
        />
    </div>
}